import React from 'react'
import PropTypes from 'prop-types'
import {
  Dropdown
} from 'react-bootstrap'
import style from './style.css'

export default function MobileFilterDropdown (props) {
  const {
    updateSelectedCategory,
    categories,
    selectedCategory
  } = props

  return (
    <Dropdown
      id="mobile-category-dropdown"
      onSelect={updateSelectedCategory}
    >
      <Dropdown.Toggle className={style.mobileDropdown}>
        {categories[selectedCategory]}
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {Object.keys(categories).map((categoryKey, index) => {
          const category = categories[categoryKey]
          return (
            <Dropdown.Item
              eventKey={categoryKey}
              key={`${category}-${index}`}
              className={style.mobileNavItem}
            >
              {category}
            </Dropdown.Item>
          )
        })}
      </Dropdown.Menu>
    </Dropdown>
  )
}

MobileFilterDropdown.propTypes = {
  updateSelectedCategory: PropTypes.func.isRequired,
  categories: PropTypes.object.isRequired,
  selectedCategory: PropTypes.string.isRequired
}
